import { IViewSettings } from "./ViewSettings"

export const SHOW_CLOSED_SHIPPING_ORDERS_DEFAULT = false

export interface IViewSettingsShippingOrders {
    showClosedShippingOrders?: boolean
}

export default class ViewSettingsShippingOrders implements IViewSettings {
    showClosedShippingOrders: boolean = SHOW_CLOSED_SHIPPING_ORDERS_DEFAULT

    constructor(data: IViewSettingsShippingOrders) {
        if (typeof data.showClosedShippingOrders !== "undefined") {
            this.showClosedShippingOrders = data.showClosedShippingOrders
        }
    }

    get isDefault() {
        return this.showClosedShippingOrders === SHOW_CLOSED_SHIPPING_ORDERS_DEFAULT
    }
}
